<div class="TootTiptopSection">  
    <button  class="dialog-close-btn"  aria-label="close dialog" mat-dialog-close>
        <img src="/icons/close-kb.svg" alt="" class="close" width="25" />
      </button>
    </div>
    
    <mat-dialog-content class="TootTip-content">
      <p class="TootTip-tittle">{{ToolTipTittle| cxTranslate}}</p>
        <div class="description">
            {{ToolTipContent| cxTranslate}}
            <br>
            {{ToolTipContent1| cxTranslate}}
          </div>
    </mat-dialog-content>